import {
    GET_BANK,
    GET_BANK_SUCCESS,
    GET_BANK_FAILURE,
    UPDATE_BANK_STATUS,
    UPDATE_BANK_STATUS_SUCCESS,
    UPDATE_BANK_STATUS_FAILURE,
    DELETE_BANK,
    DELETE_BANK_SUCCESS,
    DELETE_BANK_FAILURE,
    EDIT_BANK,
    EDIT_BANK_SUCCESS,
    EDIT_BANK_FAILURE,
    ADD_BANK,
    ADD_BANK_SUCCESS,
    ADD_BANK_FAILURE,
    COPY_BANK,
    COPY_BANK_SUCCESS,
    COPY_BANK_FAILURE
} from "../Constants";

export const GetBank = (payload) => ({
    type: GET_BANK,
    payload
});

export const GetBankSuccess = (payload) => ({
    type: GET_BANK_SUCCESS,
    payload
});

export const GetBankFailure = (payload) => ({
    type: GET_BANK_FAILURE,
    payload
});

export const UpdateBankStatus = (payload) => ({
    type: UPDATE_BANK_STATUS,
    payload
});

export const UpdateBankStatusSuccess = (payload) => ({
    type: UPDATE_BANK_STATUS_SUCCESS,
    payload
});

export const UpdateBankStatusFailure = (payload) => ({
    type: UPDATE_BANK_STATUS_FAILURE,
    payload
});

export const DeleteBank = (payload) => ({
    type: DELETE_BANK,
    payload
});

export const DeleteBankSuccess = (payload) => ({
    type: DELETE_BANK_SUCCESS,
    payload
});

export const DeleteBankFailure = (payload) => ({
    type: DELETE_BANK_FAILURE,
    payload
});

export const EditBank = (payload) => ({
    type: EDIT_BANK,
    payload
});

export const EditBankSuccess = (payload) => ({
    type: EDIT_BANK_SUCCESS,
    payload
});

export const EditBankFailure = (payload) => ({
    type: EDIT_BANK_FAILURE,
    payload
});

export const AddBank = (payload) => ({
    type: ADD_BANK,
    payload
});

export const AddBankSuccess = (payload) => ({
    type: ADD_BANK_SUCCESS,
    payload
});

export const AddBankFailure = (payload) => ({
    type: ADD_BANK_FAILURE,
    payload
});

export const CopyBank = (payload) => ({
    type: COPY_BANK,
    payload
});

export const CopyBankSuccess = (payload) => ({
    type: COPY_BANK_SUCCESS,
    payload
});

export const CopyBankFailure = (payload) => ({
    type: COPY_BANK_FAILURE,
    payload
});


